import { resource } from '../resource'

export const {
  create: createSession,
  deleteSingleton: deleteSession
} = resource('sessions')
